import { atom } from 'recoil';
import persistAtom from './recoilPersist';

export type PickUpInfoStateType = {
  // 集荷先情報の取得
  pickupInfo: {
    lmMatterId: string;
    addressZipCode: string;
    addressPrefecture: string;
    addressCity: string;
    addressTown: string;
    addressOptional: string;
    tel: string;
  };
};

export const PickUpInfoState = atom<PickUpInfoStateType>({
  key: 'PickUpInfoState',
  default: {
    // 集荷先情報の取得
    pickupInfo: {
      lmMatterId: '',
      addressZipCode: '',
      addressPrefecture: '',
      addressCity: '',
      addressTown: '',
      addressOptional: '',
      tel: '',
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default PickUpInfoState;
